import api from "@/services/api";

export async function getdata(link, parameter = {}) {
  try {
    const res = await api.get(link, {
      params: parameter,
    });

    return res.data;
  } catch (error) {
    return error;
  }
}

export async function postdata(link, parameter = {}) {
  try {
    const res = await api.post(link, parameter);

    return res;
  } catch (error) {
    return error;
  }
}